angular.module('components.media.image', [
  'stack',
  'components.media.ImageController'
])

/**
 * The componentImage provides a preview
 * of the image item type
 *
 * @class componentImage
 * @constructor
 * @module components.media.image
 * @example
 *   <component-image
 *     model="form.model">
 *   </component-image>
 */
.directive('componentImage', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: 'components/media/image/image.html',
      controller: 'ImageController'
    };
  }
]);
